<template>
  <!-- 固件版本，查看更多 -->
        <el-drawer
        :append-to-body="true"
        class="drawer"
        size="40%"
        :withHeader="true"
        show-close
          :visible.sync="moreView.moreVisible"
          :with-header="false">
          <template slot="title">
            <div class="title">设备固件详情</div>
          </template>
             <!-- 数据展示区域 -->
            <div class="showDataView2">
              <el-table
                border
                height="100%"
                :data="list"
                tooltip-effect="dark"
                style="width: 100%">
                <el-table-column
                  prop="moduleName"
                  label="模块名称">
                </el-table-column>
                <el-table-column
                  prop="moduleVersion"
                  label="模块固件版本">
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <paging
              class="paging"
              @changePage="changePage"
              :total="total"/>
        </el-drawer>
</template>
<script>
import paging from '@/components/paging'
export default {
  components: {
    paging
  },
  data () {
    return {
      total: this.firmwareList.length,
      listQuery: {
        page: 1,
        limit: 10
      },
      list: []
    }
  },
  methods: {
    changePage (val) {
      console.log('传递过来页码对象：', val)
      const startIndex = (val.page - 1) * val.limit
      const endIndex = startIndex + val.limit
      const list = this.firmwareList.slice(startIndex, endIndex)
      this.list.splice(0, this.list.length, ...list)
    }
  },
  created () {
    this.list = this.firmwareList.slice(0, this.listQuery.limit);
    let x = this.listQuery;
    let y = this.firmwareList;
    debugger;
  },
  props: {
    moreView: {
      type: Object
    },
    firmwareList: {
      type: Array
    }
  }
}
</script>
<style lang="less" scope>
.drawer{
    .title{
      font-size: 20px;
    }
    .el-drawer__body{
      margin: 10px 20px;
      display: flex;
      flex-direction: column;
    }
    .showDataView2{
      height: 90%;
    }
    .paging{
      margin-top: 10px;
    }
  }
</style>
